export const tipTapArtifactClassNames = ['ProseMirror-separator', 'ProseMirror-trailingBreak']
